"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonSymbols = exports.sortQuotes = exports.parseSpotSymbolInfo = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const constants_1 = require("./constants");
function parseSpotSymbolInfo(symbol) {
    var _a, _b;
    const { base, quote } = symbol;
    if (base && quote) {
        const displaySymbolArr = symbol.display_name.split("/");
        const baseDisplay = (_a = displaySymbolArr === null || displaySymbolArr === void 0 ? void 0 : displaySymbolArr[0]) !== null && _a !== void 0 ? _a : base;
        let quoteDisplay = (_b = displaySymbolArr === null || displaySymbolArr === void 0 ? void 0 : displaySymbolArr[1]) !== null && _b !== void 0 ? _b : "";
        // 杠杆代币
        const isBaseLeverage = base.match("[0-9][MP]$") !== null;
        const isLeverage = isBaseLeverage;
        const type = isLeverage ? trade_utils_lib_1.ExchangeSymbolType.leveraged_coin : trade_utils_lib_1.ExchangeSymbolType.spot;
        return {
            quoteDisplay,
            baseDisplay,
            isLeverage,
            type,
        };
    }
    return {
        baseDisplay: base,
        quoteDisplay: "",
        isLeverage: false,
        type: trade_utils_lib_1.ExchangeSymbolType.unknown,
    };
}
exports.parseSpotSymbolInfo = parseSpotSymbolInfo;
// 对quote进行排序，btc,eth,usdt放前面，模拟币放最后
function sortQuotes(quotes) {
    quotes = quotes.slice();
    const result = [];
    constants_1.quoteSortList.forEach((quote) => {
        const index = quotes.indexOf(quote);
        if (index !== -1) {
            result.push(quote);
            quotes.splice(index, 1);
        }
    });
    if (quotes.length > 0) {
        result.push(...quotes.sort());
        // 将模拟币quote移动到最后
        const demoIndex = result.findIndex((q) => q.includes(constants_1.VIRTUAL_CURRENCY));
        if (demoIndex !== -1 && demoIndex !== result.length - 1) {
            const demoQuote = result.splice(demoIndex, 1);
            result.push(...demoQuote);
        }
    }
    return result;
}
exports.sortQuotes = sortQuotes;
function getCommonSymbols(coin) {
    return [`${coin}/USDT`, `${coin}/BTC`, `${coin}/ETH`, `BTC/${coin}`, `BTC.PERP/${coin}`];
}
exports.getCommonSymbols = getCommonSymbols;
